export default {
  from: (email) => email,
  to: (email) => email,
  subject: () => `Climate Check®️ Premium Report Order`,
  data: (data) => data,
  body: (data) => {
    return data.propertyAddress
  },
}
